import { render, staticRenderFns } from "./RegisteredProductsActiveRepair.vue?vue&type=template&id=1d9070f4"
import script from "./RegisteredProductsActiveRepair.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsActiveRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports